module.exports = __webpack_public_path__ + "static/media/jeff.3053d8ab.png";